import { authModule } from '@/stores'
import { APIClientBase } from './api-client-base'
import { AuthAdminPostRequest, AuthAdminPostResponse } from '@//dtos/auth/admin/post'
import { IdentificationPostRequest, IdentificationPostResponse } from '@/dtos/auth/identification/post'
import { AdditionalIdentificationPostRequest, AdditionalIdentificationPostResponse } from '@/dtos/auth/identification/additional/post'
import { LoginPostRequest, LoginPostResponse } from '@/dtos/auth/login/post'
import { LogoutRedirectUrlGetResponse } from '@/dtos/auth/logout/get-redirect-url'
import { SimulateLoginPostRequest, SimulateLoginPostResponse } from '@/dtos/auth/simulate/post'
import { AuthYuipotaAuthResponse } from '@/dtos/auth/disaster/get'
import { YuipotaTokenResponse } from '@/dtos/auth/disaster/token/get'
import { MockLoginPostRequest, MockLoginPostResponse } from '@/dtos/auth/login/post-mock-login'
import { AuthorizeRedirectUrlGetRequest, AuthorizeRedirectUrlGetResponse } from '@/dtos/auth/login/get-redirect-url'

class AuthClient extends APIClientBase {
  constructor() {
    super('/auth/')
  }

  postLogin(req: LoginPostRequest): Promise<LoginPostResponse | undefined> {
    return this.post('login', req, LoginPostResponse, true, { 'X-SM-STATE-KEY': authModule.stateKey })
  }

  postMockLogin(req: MockLoginPostRequest): Promise<MockLoginPostResponse | undefined> {
    return this.post('mock-login', req, MockLoginPostResponse)
  }

  getLogoutRequestRedirectUrl(): Promise<LogoutRedirectUrlGetResponse | undefined> {
    return this.get('logout-redirect-url', undefined, LogoutRedirectUrlGetResponse)
  }

  postLogout() {
    return this.post('logout', undefined)
  }

  postIdentification(req: IdentificationPostRequest): Promise<IdentificationPostResponse | undefined> {
    return this.post('identification', req, IdentificationPostResponse)
  }

  postAdditionalIdentification(req: AdditionalIdentificationPostRequest): Promise<AdditionalIdentificationPostResponse | undefined> {
    return this.post('identification/additional', req, AdditionalIdentificationPostResponse)
  }

  getAuthorizeRedirectUrl(req: AuthorizeRedirectUrlGetRequest): Promise<AuthorizeRedirectUrlGetResponse | undefined> {
    return this.get('authorize-redirect-url', req, AuthorizeRedirectUrlGetResponse)
  }

  postAdminLogin(req: AuthAdminPostRequest): Promise<AuthAdminPostResponse | undefined> {
    return this.post('admin', req, AuthAdminPostResponse)
  }

  postSimulateLogin(req: SimulateLoginPostRequest): Promise<SimulateLoginPostResponse | undefined> {
    return this.post('simulate', req, SimulateLoginPostResponse)
  }

  postYuipotaAuth(): Promise<AuthYuipotaAuthResponse | undefined> {
    return this.post('yuipota', undefined, AuthYuipotaAuthResponse)
  }

  getYuipotaToken(): Promise<YuipotaTokenResponse> {
    return this.get('/yuipota/token', undefined, YuipotaTokenResponse)
  }
}

export const authClient = new AuthClient()
